module.exports = __webpack_public_path__ + "img/shutdown-injector.4ea6c3f9.svg";